<template >
  <div class="primary-panel" v-show="flag">
    <PanelHeader />
    <ControlPanel />
  </div>
  <div :class="displayZone" id="displayZone">
    <DisplayHeader />
    <!-- <router-view /> -->
    <!-- <div class="header">
      <DisplayHeader />
    </div> -->
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script  setup>
import ControlPanel from './components/ControlPanel.vue';
import DisplayHeader from './components/DisplayHeader.vue';
import PanelHeader from './components/PanelHeader.vue';
//先安装mitt再创建utils/event-bus.js   npm  i mitt
import emitter from "./utils/event-bus.js";
import { ref } from "vue";
import { onMounted } from "vue";



// 修改element-ui的样式
onMounted(() => {
  document.body.style.setProperty("--el-color-primary", '#4caf50');
  document.body.style.setProperty("--el-color-primary-light-3", '#378358');
  document.body.style.setProperty("--el-color-primary-dark-2", '#378358');
  initAppVh()
});

let displayZone = ref('displayZone-min');
let flag = ref(true);

emitter.on("show-panel", () => {
  flag.value = true;
  displayZone.value = "displayZone-min";
});
// 引入数据文件 
import { useWindBaseDataStore } from './store/windBaseData';
import { getData } from "./assets/JS/Power_WB_DATA.js";
const windBaseData = useWindBaseDataStore();
windBaseData.data = getData();


emitter.on("hide-panel", () => {
  flag.value = false;
  displayZone.value = "displayZone-max";
});

// 页面初始化时调用，因为移动浏览器100vh高度未适应屏幕大小，CSS中设置height: calc(var(--vh, 1vh) * 100)
function initAppVh() {
  // 获取视口区域高度并将其乘以1%以获得1vh单位的值
  let vh = window.innerHeight * 0.01;
  // 然后将——vh自定义属性中的值设置为文档的根
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // 监听窗口resize事件 视图大小发生变化就重新计算1vh的值
  window.addEventListener('resize', () => {
    // 执行与前面相同的脚本计算1vh的值
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
}
</script>

<style lang="less" scoped>
#displayZone,
.primary-panel {
  position: relative;
  height: 100vh;
  overflow: hidden;
}


.header {
  width: calc(100%);
  position: relative;

}

.content {
  position: relative;
  width: calc(100%);
  height: calc(100%);
  overflow: hidden;
}

.vue-puzzle-vcode {
  left: 200px;
}


@media (orientation: portrait) and (max-width: 768px) {

  .primary-panel,
  #displayZone {
    height: calc(var(--vh, 1vh) * 100)
  }

}
</style>
